import './NoSearchResult.scss';

export const NoSearchResult = () => {
  return (
    <h1 className="NoSearchResult">
      Sorry, we can not find your product
    </h1>
  );
};
